export const GET_GESTIONI_NUMERI_NERI_DATA_AND_LOADING =
  "GET_GESTIONI_NUMERI_NERI_DATA_AND_LOADING";
export const CREATE_NUMERI_NERI_DATA = "CREATE_NUMERI_NERI_DATA";
export const CREATE_UPDATE_DELETE_NUMERI_NERI =
  "CREATE_UPDATE_DELETE_NUMERI_NERI";
export const GET_CURRENT_NUMERI_NERI = "GET_CURRENT_NUMERI_NERI";
export const EXPORT_NUMERI_NERI_LOADING = "EXPORT_NUMERI_NERI_LOADING";
